export const PACKAGE_NAME = 'jira-business.project-list-template-picker';
